import useCurrentLocation from "Hooks/useCurrentLocation";
import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import { useEffect, useRef, useState } from "react";
import { BiExit, BiPhoneCall } from "react-icons/bi";
import { BsCart, BsLaptop } from "react-icons/bs";
import { FcBusinessman } from "react-icons/fc";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdHomeWork } from "react-icons/md";
import { PiPasswordBold } from "react-icons/pi";
import { RiMenuFoldLine } from "react-icons/ri";
import { TbReportMoney } from "react-icons/tb";
import { useSelector } from "react-redux";

// ملاحظة: قمت بتعديل الأيقونات لتكون مجرد المكون (Component) لسهولة التحكم في الحجم واللون داخل الخريطة (Map)
const links = [
  { url: "/cp", icon: MdHomeWork, title: "الرئيسية" },
  { url: "/laptops", icon: BsLaptop, title: "اللابتوبات" },
  { url: "/my-cart", icon: BsCart, title: "سلة المشتريات" },
  { url: "/cp/my-orders", icon: IoDocumentTextOutline, title: "حجوزاتي" },
  // { url: "/my-cart", icon: TbReportMoney, title: "دفعاتي المالية" },
  { url: "/cp/contact-us", icon: BiPhoneCall, title: "تواصل معنا" },
  {
    url: "/cp/change-password",
    icon: PiPasswordBold,
    title: "تغير كلمة المرور",
  },
  { url: "/logout", icon: BiExit, title: "خروج" },
];

export default function Account() {
  const currentLocation = useCurrentLocation();
  const navigate = useViewTransitionNavigate();
  const { name } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="hidden lg:inline-flex relative py-1 font-[Tajawal]">
      {/* الزر الرئيسي */}
      <button
        ref={buttonRef}
        type="button"
        onClick={toggleDropdown}
        className={`flex items-center justify-center w-10 h-10 rounded-xl border-2 transition-all duration-300 
          ${
            isOpen
              ? "bg-mainLight border-mainLight text-white shadow-lg shadow-mainLight/20"
              : "border-mainLight/30 text-mainLight hover:bg-mainLight/10"
          }`}
      >
        <RiMenuFoldLine
          className={`text-xl transition-transform duration-500 -rotate-90 ${
            isOpen && "-scale-x-100"
          } `}
        />
      </button>

      {/* القائمة المنسدلة */}
      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute z-50 mt-3 w-64 top-full right-0 overflow-hidden
             bg-gray-100/90 dark:bg-gray-950/90 backdrop-blur-sm 
             border border-white/40 dark:border-white/10 
             rounded-[1.5rem] shadow-2xl animate-in fade-in slide-in-from-top-2"
        >
          {/* قسم المستخدم */}
          <div className="p-5 flex flex-col items-center border-b border-gray-100 dark:border-white/5 bg-gray-50/50 dark:bg-white/5">
            <div
              className="relative group cursor-pointer"
              onClick={() => {
                navigate("/cp/my-profile");
                setIsOpen(false);
              }}
            >
              <div className="p-1 rounded-full border-2 border-mainLight/20 group-hover:border-mainLight transition-colors">
                <FcBusinessman className="text-5xl" />
              </div>
              <div className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 border-2 border-white dark:border-gray-950 rounded-full"></div>
            </div>
            <h1 className="mt-3 text-sm font-bold text-gray-800 dark:text-white">
              {name}
            </h1>
            <span className="text-[10px] text-mainLight font-bold uppercase tracking-wider">
              الحساب الشخصي
            </span>
          </div>

          {/* الروابط */}
          <ul className="p-2 space-y-1">
            {links.map((link, index) => {
              const Icon = link.icon;
              const isActive = currentLocation === link.url;
              return (
                <li key={index}>
                  <button
                    onClick={() => {
                      navigate(link.url);
                      setIsOpen(false);
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-300 group
                      ${
                        isActive
                          ? "bg-mainLight/10 text-mainLight font-bold"
                          : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/5 hover:text-mainLight"
                      }`}
                  >
                    <span
                      className={`text-lg transition-transform duration-300 group-hover:scale-110 ${
                        isActive
                          ? "text-mainLight"
                          : "text-gray-400 dark:text-gray-500 group-hover:text-mainLight"
                      }`}
                    >
                      {typeof Icon === "function" ? <Icon /> : Icon}
                    </span>
                    <span className="text-xs">{link.title}</span>
                  </button>
                </li>
              );
            })}
          </ul>

          {/* تذييل القائمة */}
          <div className="p-3 bg-gray-50 dark:bg-white/5 text-center">
            <p className="text-[9px] text-gray-400 font-medium">
              العالمية للابتوب © 2025
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
